import * as React from 'react'
import {MissionTitleContainer, Title, TitleContent, TitleTextWrapper} from './MissionTitle.elements'

type Props = {
  title: string
  imageUrl: string
  imageUrlMobile: string
}

export const MissionTitle: React.FunctionComponent<Props> = ({title, imageUrl, imageUrlMobile}) => (
  <MissionTitleContainer imageUrl={imageUrl} imageUrlMobile={imageUrlMobile}>
    <TitleContent>
      <TitleTextWrapper>
        <Title dangerouslySetInnerHTML={{ __html: title }}/>
      </TitleTextWrapper>
    </TitleContent>
  </MissionTitleContainer>
)